import React, {useState, useEffect, Fragment} from 'react';
import {ListaNonConformita, TextHighlight, AddButton, NewDeviceField, CheckIcon, UserIcon, BackButton, VisDiv, Photos, Comments,Loading, ViewLabelValueField, FieldDropdown} from '../components';
import {FiEdit} from 'react-icons/fi'
import { RiSave3Fill } from "react-icons/ri";
import { TiDelete } from 'react-icons/ti';
import { v4 as uuidv4, v4 } from 'uuid';
import { keyId } from '../lib/utils';
import { useStateContext } from '../context/StateContext';

const ContactDetail = ({contact=[], index, saveFn, alwaysEdit, noArchive, resetAfterSave}) => {

  const {LDB} = useStateContext();
  const [values, setValues] = useState(contact)
  const [edit, setEdit] = useState(alwaysEdit)

  const emptyDoc = {
    _id: uuidv4(),
    _key: keyId(),
    _type: "contactDetail",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    secondaryPhoneNumber: "",
}
  const empty = () => {
     if(!values?.firstName &&
        !values?.lastName && 
        !values?.email &&
        !values?.phoneNumber &&
        !values?.secondaryPhoneNumber
    ){ return false }
    return true
  }
  const editingToggle = () => {
      setEdit(!edit)
  }
  const save = () => {
      //console.log("SAVE", values)
      saveFn(values)
      
      if(!alwaysEdit){
        setEdit(false)
      }
      if(resetAfterSave){
        setValues(emptyDoc)
      }
  }
  const archive = () => {
      //console.log("ARCHIVE", values)
      saveFn({...values, status:"ARCHIVIATO"})
      setEdit(false)
  }
  const commonFieldData = {
    values,
    edit,
    setValues,
    save
  } 
  return (

        <VisDiv className= "device-pin-container">

            <div className='center-container' style={{paddingRight:"25px"}}>
                <div className='device-title-container'>
                    <PinField data={{...commonFieldData, objKey:"firstName", label: LDB("contacts", "firstName"), value:contact?.firstName}} />
                    <PinField data={{...commonFieldData, objKey:"lastName", label: LDB("contacts", "lastName"),value:contact?.lastName}} />
                    <PinField data={{...commonFieldData, objKey:"email", label: LDB("contacts", "email"),value:contact?.email}} />
                    <PinField data={{...commonFieldData, objKey:"phoneNumber", label: LDB("contacts", "landLine"),value:contact?.phoneNumber}} />
                    <PinField data={{...commonFieldData, objKey:"secondaryPhoneNumber", label: LDB("contacts", "mobile"), value:contact?.secondaryPhoneNumber}} />
                    <VisDiv rules={[edit || alwaysEdit]} style={{display: "flex", marginBottom:"15px"}}>
                        <VisDiv rules={[empty()]}> 
                            <button type="button" style={{backgroundColor: "green"}} className="btn" onClick={()=>save()} >
                                 {LDB("misc", "save")}
                            </button>    
                        </VisDiv>
                        <VisDiv style={{marginLeft:"15px"}} rules={[!noArchive]}> 
                            <button type="button" style={{backgroundColor: "grey"}} className="btn" onClick={()=>setEdit(false)} >
                                {LDB("misc", "cancel")}
                            </button> 
                        </VisDiv>
                        <VisDiv  style={{marginLeft:"15px"}} rules={[!noArchive]}>                    
                            <button type="button" style={{backgroundColor: "red"}} className="btn" onClick={()=>archive()} >
                                {LDB("misc", "archive")}
                            </button>  
                        </VisDiv>         
                    </VisDiv>
                </div>
            </div>
            <div style={{backgroundColor:"white", marginRight:"5px", display:"flex", justifyContent:"flex-end", paddingLeft:"30px"}} className='icons-container'>
                <div className='icon-container' style={{display:"flex", flexDirection:"column", justifyContent:"space-evenly", alignItems:"flex-end"}}>
                    <VisDiv rules = {[!edit]}>
                        <button type='button' className='round-back-button' style={{backgroundColor:"red",marginRight:"25px"}} onClick={()=>editingToggle()}>
                            <FiEdit              
                            size={15}
                            color={"white"}/>
                        </button>
                    </VisDiv> 
                </div> 
            </div>        
        </VisDiv>

  )
}

export default ContactDetail


const PinField = ({data={}}) => {
    const {LDB} = useStateContext();
    const {label, setValues, values=[], objKey, edit, save} = data
    const value = values[objKey]
    const translatedLabel = () => {
        if (label == "NOME") return 
    }

    return(
        <div className='device-title-container'>
            <VisDiv rules={[value || edit]} style={{display: "flex", padding:"5px", justifyContent:"center", alignItems:"center"}}>
                <div style={{marginRight:"5px"}}>
                    <p>{`${label}: `}</p>
                </div>
                <VisDiv rules={[!edit]}>
                    <h4 className='device-info-text'> {value}</h4>
                </VisDiv>
                <VisDiv rules={[edit]}>
                    <input
                        ///ref={searchRef}
                        type="text"
                        //onBlur={save}
                        onChange={(e) => setValues({...values, [objKey]:e.target.value})}
                        placeholder = {label}
                        value={value}
                        className='text-input'
                    />
                </VisDiv>
            </VisDiv> 
        </div>
    )
}